// 首页
export default {
    displayInfo: '显示信息',
    user: '用户',
    pleaseEnterId: '请输入设备SN',
}